import {
  IUser,
  isAccessAllowed,
  isAccessAllowedByBusinessUnitId,
  isAccessAllowedByOneOf,
} from '@crm-framework/auth';

import { IS_BU_RIGHT } from './consts';

export const checkRightsByUser = ({
  user,
  rightsToCheck,
  isAccessAllowedByOneOfRight = false,
  businessUnitId,
}: {
  user: IUser | null;
  rightsToCheck: string[];
  businessUnitId?: number;
  isAccessAllowedByOneOfRight?: boolean;
}): boolean => {
  if (!user) {
    return false;
  }

  if (businessUnitId) {
    const result = rightsToCheck.map((right) =>
      IS_BU_RIGHT[right]
        ? isAccessAllowedByBusinessUnitId(
            user.businessUnitRights,
            businessUnitId,
            [right]
          )
        : checkRightsByUser({
            user,
            rightsToCheck: [right],
          })
    );

    return isAccessAllowedByOneOfRight
      ? result.some((item) => item === true)
      : result.every((item) => item === true);
  }

  return isAccessAllowedByOneOfRight
    ? isAccessAllowedByOneOf(user.rights, rightsToCheck)
    : isAccessAllowed(user.rights, rightsToCheck);
};
